import { render, staticRenderFns } from "./SelectableTab.vue?vue&type=template&id=630e3edb&scoped=true&"
import script from "./SelectableTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectableTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SelectableTab.vue?vue&type=style&index=0&id=630e3edb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e3edb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630e3edb')) {
      api.createRecord('630e3edb', component.options)
    } else {
      api.reload('630e3edb', component.options)
    }
    module.hot.accept("./SelectableTab.vue?vue&type=template&id=630e3edb&scoped=true&", function () {
      api.rerender('630e3edb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SelectableTab/SelectableTab.vue"
export default component.exports